import { supabase } from '../supabaseClient';
import { SAYFA_CONFIGS } from '../config/sayfaConfig';
import i18n from '../i18n';

function setNestedKey(obj, path, value) {
  const keys = path.split('.');
  let cur = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    if (cur[keys[i]] === undefined || typeof cur[keys[i]] !== 'object') cur[keys[i]] = {};
    cur = cur[keys[i]];
  }
  cur[keys[keys.length - 1]] = value;
  return obj;
}

export async function applySayfaOverrides() {
  try {
    const override = {};

    // 1) sayfa_icerikleri (JSON blob per page - eski sistem)
    const { data: sayfaData } = await supabase
      .from('sayfa_icerikleri')
      .select('sayfa_id, icerik');
    if (sayfaData && sayfaData.length > 0) {
      sayfaData.forEach(row => {
        const config = SAYFA_CONFIGS[row.sayfa_id];
        if (!config || !row.icerik) return;
        config.fields.forEach(field => {
          const val = row.icerik[field.key];
          if (val !== undefined && val !== null && val !== '') {
            setNestedKey(override, field.i18nKey, val);
          }
        });
      });
    }

    // 2) metin_overrides (flat key-value - yeni sistem, tüm sayfaları kapsar)
    const { data: metinData } = await supabase
      .from('metin_overrides')
      .select('key, value');
    if (metinData && metinData.length > 0) {
      metinData.forEach(row => {
        if (row.key && row.value !== null && row.value !== '') {
          setNestedKey(override, row.key, row.value);
        }
      });
    }

    if (Object.keys(override).length > 0) {
      i18n.addResourceBundle('tr', 'translation', override, true, true);
    }
  } catch (e) {
    console.warn('Sayfa içerikleri yüklenemedi:', e);
  }
}
